<script>
  // /login is the documented entry point for protected paths: unauthenticated
  // visits get bounced here, then we hand off to login.telebroad.com via the
  // server's /auth/login redirect. Authenticated users who land here are
  // already in -- send them home instead of forcing another round-trip.
  import { onMount } from 'svelte';
  import { getToken, loginRedirect } from '../lib/auth.js';
  import Splash from '../components/Splash.svelte';

  onMount(() => {
    if (getToken()) {
      window.location.replace('/');
    } else {
      loginRedirect();
    }
  });
</script>

<Splash />
